import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks/useIsScreenSize';
import { isDefined, isNull } from '@app/utils/is';
import { Toasts } from '@typings';
import React from 'react';

import { ToastBar } from './ToastBar';
import { useToaster } from './useToaster';

interface Props {
  toast: Toasts.Toast;
}

export const ToastWrapper = ({ toast }: Props) => {
  const { handlers } = useToaster();
  const ref = React.useRef<HTMLDivElement>(null);

  const isMobile = useIsScreenSize(BREAKPOINTS.SM);

  React.useEffect(() => {
    if (isDefined(toast.height) || isNull(ref.current)) {
      return;
    }

    const boundingRect = ref.current.getBoundingClientRect();
    handlers.updateHeight(toast.id, boundingRect.height);
  }, [toast, ref]);

  const offset = handlers.calculateOffset(toast);

  return (
    <div
      ref={ref}
      className="absolute bottom-0 left-0 right-0 flex justify-end transition-transform sm:bottom-auto sm:top-0"
      style={{ transform: `translateY(${isMobile ? -offset : offset}px)`, zIndex: toast.visible ? 1 : -1 }}
      data-testid="toast"
    >
      <ToastBar {...toast} />
    </div>
  );
};
